import axios from "axios";
import { SET_LABELS } from "./types";

//Register Labels
export const registerLabel = () => (dispatch) => {
  axios
    .get("/api/label")
    .then((res) => {
      if (res.data) {
        let temp = {};
        for (let key in res.data) {
          if (key == "_id" || key == "__v") continue;
          let str = res.data[key];
          temp[key] = str.split(",");
        }
        dispatch({
          type: SET_LABELS,
          payload: temp,
        });
      }
    })
    .catch((err) => {});
};
